import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { getPageSeo, getCanonicalUrl, getOgLocale } from './seoConfig';
interface SeoHeadProps {
  page: string;
}
function setMetaTag(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
}
function setLinkTag(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}
export function SeoHead({
  page
}: SeoHeadProps) {
  const {
    language
  } = useLanguage();
  useEffect(() => {
    const seo = getPageSeo(page, language);
    const canonical = getCanonicalUrl(page);
    const ogLocale = getOgLocale(language);
    // Title
    document.title = seo.title;
    // Standard meta
    setMetaTag('description', seo.description);
    setMetaTag('keywords', seo.keywords);
    // Open Graph
    setMetaTag('og:title', seo.title, true);
    setMetaTag('og:description', seo.description, true);
    setMetaTag('og:type', seo.ogType || 'website', true);
    setMetaTag('og:url', canonical, true);
    setMetaTag('og:site_name', 'AstroGuide', true);
    setMetaTag('og:locale', ogLocale, true);
    setMetaTag('og:image', 'https://astroguide.ru/og-image.jpg', true);
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', seo.title);
    setMetaTag('twitter:description', seo.description);
    setMetaTag('twitter:image', 'https://astroguide.ru/og-image.jpg');
    // Canonical
    setLinkTag('canonical', canonical);
    // HTML lang attribute
    document.documentElement.lang = language;
    document.documentElement.dir = 'ltr';
  }, [page, language]);
  return null;
}